import * as React from 'react'
import { FC, useState } from 'react'
import Invitation from 'entities/cooperation/invitation'
import styles from './invitation_sharing.module.scss'
import { FiLink, FiShare } from 'react-icons/fi'
import * as copy from 'copy-to-clipboard'
import Tooltip from 'components/tooltip'

type Props = {
  invitation: Invitation
}

export const InvitationSharing: FC<Props> = ({ invitation }) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [copied, setCopied] = useState(false)

  const copyClipboard = () => {
    const copied = copy(invitation.url)
    setCopied(copied)
    setShowTooltip(true)
    setTimeout(() => setShowTooltip(false), 3000)
  }

  const shareApiEnable = (window.navigator as any).share
  const shareSNS = () => {
    const nav = window.navigator as any
    nav.share({ url: invitation.url })
  }

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>
        {I18n.t('offers.pages.show.components.invitation_sharing.title', {
          name: invitation.name
        })}
      </h2>
      <div className={styles.methods}>
        <div className={styles.method}>
          <Tooltip
            className={styles.tooltip}
            message={
              copied
                ? I18n.t('offers.pages.show.components.invitation_sharing.success')
                : I18n.t('offers.pages.show.components.invitation_sharing.failure')
            }
            hidden={!showTooltip}
            placement={`top`}
          />
          <button type="button" className={styles.button} onClick={copyClipboard}>
            <FiLink size={35} />
          </button>
          <span>{I18n.t('offers.pages.show.components.invitation_sharing.copy')}</span>
        </div>
        {shareApiEnable ? (
          <div className={styles.method}>
            <button type="button" className={styles.button} onClick={shareSNS}>
              <FiShare size={35} />
            </button>
            <span>{I18n.t('offers.pages.show.components.invitation_sharing.share_sns')}</span>
          </div>
        ) : null}
      </div>
      <div className={styles.fallbackBlock}>
        <p className={styles.fallbackHelpText}>
          {I18n.t('offers.pages.show.components.invitation_sharing.copy_fallback')}
        </p>
        <input type="url" className={styles.fallbackInput} value={invitation.url} readOnly={true} />
      </div>
    </div>
  )
}
